import { LOCALE } from "./intl-wrapper";

export const LANGUAGES_OPTIONS = [
  {
    value: LOCALE.EN,
    label: 'EN'
  },
  {
    value: LOCALE.AR,
    label: 'عربي'
  }
];
